module.exports = __webpack_public_path__ + "8fe2aca313ad05cd3b055905922185fd.jpg";